import { FC, useState, useEffect, useCallback, } from "react";
import { useParams } from "react-router";
import { SystemMessageForm } from "./SystemMessageForm";
import { routes } from "../../../../utils/constants/routes";
import { URLS } from "../../../../utils/constants/urls";
import axiosInstance from "../../../../utils/axios";
import AddEdit from "../../CommonPage/AddEdit";
import strings from "../../../../common/Translation/Translate";
import LanguageDrodownValue from "../../../../utils/hooks/LanguageDrodownValue";

const AddEditSystemMessage: FC = () => {
    const { id } = useParams() as any;
    const languageList = LanguageDrodownValue() as any;
    const [pageResponse, setPageResponse] = useState<any>([]);
    const [isLoading, setIsloading] = useState<boolean>(false);
    const getPageData = useCallback(async () => {
        try {
            setIsloading(true);
            const { data } = await axiosInstance.get(URLS.get_edit_systemMessagesId(id));
            const container: any = {};
            for (let i = 0; i < languageList?.length; ++i) {
                let values = ['editor_' + languageList[i]?.value]
                container[values as any] = data.localizedAttributes[languageList[i]?.value]
                    ? data.localizedAttributes[languageList[i]?.value].text
                    : '';
            }
            console.log(container)
            setPageResponse(container);
        } catch (error: any) {
        } finally { setIsloading(false) }
    },
        [id, languageList]
    );

    useEffect(() => {
        (async () => {
            if (id) {
                await getPageData();
            }
        })();
    }, [getPageData, id]);

    useEffect(() => {
        handleSetModel()
    }, [])

    const handleSetModel = () => {
        const newArray = [] as any;
        languageList.forEach((languae: any) => {
            const newObject = { ...SystemMessageForm(strings)[0] };
            newObject.field = 'editor_' + languae.value;
            newObject.label = newObject.label + ' (' + languae.text + ')';
            newArray.push(newObject);
        }
        )
        return newArray
    }
    const pageConfig =
    {
        title: strings.systemMessage_title_edit,
        successMessage: id ? strings.common_update_message : strings.common_save_message,
        addEditApiUrl: id ? URLS.get_edit_systemMessagesId(id) : URLS.systemMessages,
        initialApi: URLS.get_edit_systemMessagesId(id),
        formModel: handleSetModel(),
        navigateToPage: routes.systemMessage,
        isCustomResponse: true,
    }

    const handleCustomResponse = (custom: any) => {
        const localizedAttributes = [] as any;
        languageList?.map((item: { text: string, value: string }) =>
            localizedAttributes.push({
                language: item.value,
                text: custom['editor_' + item.value],
            }),
        );
        return { localizedAttributes: localizedAttributes }
    }
    return (<AddEdit pageLoading={isLoading}
        pageConfig={pageConfig} pageResponse={pageResponse} handleCustomResponse={handleCustomResponse} />);
};
export default AddEditSystemMessage;